import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import WarningRounded from "@material-ui/icons/WarningRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import { Autocomplete } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Config from "Config";
import { enGB, zhCN, zhTW } from "date-fns/locale";
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import CustomDatePicker from "../../component/CustomDatePicker/CustomDatePicker";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import copyLinkIcon from "../../images/copy-link-icon.png";
import CustomMultiSelect from "../../inputComponent/CustomMultiSelect/CustomMultiSelect";
import CustomRadioGroup from "../../inputComponent/CustomRadioGroup/CustomRadioGroup";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getUserRole } from "../../redux/selector";
import { send } from "../../SendRequest";
import { isEmpty, isNotEmpty, isObjectNotEmpty } from "../../Utils";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 60,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
    shortGrid: {
        "& .react-datepicker__input-container input": {
            width: "100%",
        },
        "& .MuiInputBase-root.MuiInput-underline": {
            width: "75%",
        },
    },
    statusRadio: {
        "& .MuiFormControlLabel-root": {
            marginRight: "10px",
        },
    },
    denseTable: {
        "& .MuiTableCell-root": {
            padding: "10px 10px",
        },
    },
});

function EditPurpose() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [lang, setLang] = useState(enGB);
    useEffect(() => {
        switch (i18n.language) {
            case "tc":
                setLang(zhTW);
                break;
            case "sc":
                setLang(zhCN);
                break;
            case "en":
            default:
                setLang(enGB);
                break;
        }
    }, [i18n.language]);

    const [groupList, setGroupList] = useState([]);
    const [groupOptionList, setGroupOptionList] = useState([]);
    const [curReviewerList, setCurReviewerList] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("");
    const [addReviewer, setAddReviewer] = useState("");
    const [addReviewerMsg, setAddReviewerMsg] = useState("");
    const [sectionNameList, setFormNameList] = useState([]);
    const [addFormNameMsg, setAddFormNameMsg] = useState("");
    const [addGroupMsg, setAddGroupMsg] = useState("");
    const [copySuccessOpen, setCopySuccessOpen] = useState(false);

    const userRole = useSelector(getUserRole());

    const isAdmin = userRole === "SA";

    const rowRefs = useRef({});
    const tableContainerRef = useRef(null);
    const scrollTimeoutRef = useRef(null);

    const scrollToRow = (index) => {
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        requestAnimationFrame(() => {
            scrollTimeoutRef.current = setTimeout(() => {
                const rowElement = rowRefs.current[index];
                const container = tableContainerRef.current;

                if (rowElement && container) {
                    const rowTop = rowElement.offsetTop;
                    const rowHeight = rowElement.offsetHeight;
                    const containerHeight = container.clientHeight;

                    const scrollPosition =
                        rowTop - containerHeight / 2 + rowHeight / 2;

                    container.scrollTo({
                        top: scrollPosition,
                        behavior: "smooth",
                    });
                }
            }, 350);
        });
    };

    // 复制到剪贴板功能
    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopySuccessOpen(true);
        } catch (err) {
            console.error("Failed to copy text: ", err);
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            setCopySuccessOpen(true);
        }
    };

    // 生成URL并复制
    const copyUrl = (sectionId, lang) => {
        const encodedLang = encodeURIComponent(lang);
        const url = `${window.location.origin}${Config.CONTENT_PATH}/Form105?formId=${sectionId}&language=${encodedLang}`;
        copyToClipboard(url);
    };

    const initialDefaultValues = {
        sectionNameEn: "",
        sectionNameSc: "",
        sectionNameTc: "",
        newSectionNameEn: "",
        newSectionNameTc: "",
        newSectionNameSc: "",
        copyReo: "",
        status: "",
        openDateTime: null,
        closeDateTime: null,
        requiresSignature: "",
        telNo: "",
        collBoxGroupList: [],
        enRemark: "",
        scRemark: "",
        tcRemark: "",
        requireReo: "",
    };

    const initialGroupDefaultValues = {
        groupNameEn: "",
        groupNameSc: "",
        groupNameTc: "",
        reviewerEmail: "",
    };

    const {
        control,
        getValues,
        watch,
        setValue,
        formState,
        register,
        handleSubmit,
        reset,
        trigger,
    } = useForm({
        defaultValues: initialDefaultValues,
        mode: "onBlur",
        resolver: yupResolver(
            yup.object().shape({
                sectionNameEn: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                sectionNameSc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                sectionNameTc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                newSectionNameEn: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                newSectionNameTc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                newSectionNameSc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(300, t("errorMsg.maxTextLength", { max: 300 })),
                status: yup.string().required(t("errorMsg.required")),
                copyReo: yup.string().required(t("errorMsg.required")),
                requiresSignature: yup
                    .string()
                    .required(t("errorMsg.required")),
                telNo: yup
                    .string()
                    .notRequired()
                    .test(
                        "min length",
                        t("errorMsg.minTextLength", { min: 8 }),
                        (value) => {
                            return isEmpty(value) || value?.length >= 8;
                        }
                    )
                    .test(
                        "max length",
                        t("errorMsg.maxTextLength", { max: 50 }),
                        (value) => {
                            return isEmpty(value) || value?.length <= 50;
                        }
                    ),
                collBoxGroupList: yup.array().when("status", {
                    is: (value) => value === "active",
                    then: yup.array().min(1, t("errorMsg.required")),
                    otherwise: yup.array(),
                }),
                enRemark: yup
                    .string()
                    .notRequired()
                    .max(5000, t("errorMsg.maxTextLength", { max: 5000 })),
                scRemark: yup
                    .string()
                    .notRequired()
                    .max(5000, t("errorMsg.maxTextLength", { max: 5000 })),
                tcRemark: yup
                    .string()
                    .notRequired()
                    .max(5000, t("errorMsg.maxTextLength", { max: 5000 })),
                openDateTime: yup
                    .date()
                    .nullable()
                    .notRequired()
                    .test(
                        "is-before-close",
                        t("errorMsg.openTimeBeforeCloseTime"),
                        function (value) {
                            const { closeDateTime } = this.parent;
                            return (
                                !value ||
                                !closeDateTime ||
                                value < closeDateTime
                            );
                        }
                    ),
                closeDateTime: yup
                    .date()
                    .nullable()
                    .notRequired()
                    .test(
                        "is-after-open",
                        t("errorMsg.closeTimeAfterOpenTime"),
                        function (value) {
                            const { openDateTime } = this.parent;
                            return (
                                !openDateTime || !value || openDateTime < value
                            );
                        }
                    ),
            })
        ),
    });

    const groupForm = useForm({
        defaultValues: initialGroupDefaultValues,
        mode: "onBlur",
        resolver: yupResolver(
            yup.object().shape({
                groupNameEn: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(200, t("errorMsg.maxTextLength", { max: 200 })),
                groupNameSc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(200, t("errorMsg.maxTextLength", { max: 200 })),
                groupNameTc: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(200, t("errorMsg.maxTextLength", { max: 200 })),
                reviewerEmail: yup
                    .string()
                    .required(t("errorMsg.required"))
                    .max(200, t("errorMsg.maxTextLength", { max: 200 })),
            })
        ),
    });

    const errors = formState.errors;

    const errorCodeList = [
        "10",
        "9101",
        "9102",
        "9103",
        "9105",
        "9109",
        "2000",
        "2007",
        "9999",
    ];

    function addNewGroupItem() {
        const addGroupItem = {
            groupNameEn: groupForm.getValues("groupNameEn"),
            groupNameSc: groupForm.getValues("groupNameSc"),
            groupNameTc: groupForm.getValues("groupNameTc"),
            collBoxReviewerList: [
                { post: groupForm.getValues("reviewerEmail") },
            ],
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/addCollBoxGroup`,
            method: "POST",
            body: JSON.stringify(addGroupItem),
        };
        dispatch(send("ADD_COLLBOX_GROUP", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    groupForm.setValue("groupNameEn", "");
                    groupForm.setValue("groupNameSc", "");
                    groupForm.setValue("groupNameTc", "");
                    groupForm.setValue("reviewerEmail", "");
                    setAddGroupMsg("");
                    initGroupList();
                } else {
                    setAddGroupMsg(result?.code);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function addNewFormNameItem() {
        const addFormNameItem = {
            sectionNameEn: getValues("sectionNameEn"),
            sectionNameSc: getValues("sectionNameSc"),
            sectionNameTc: getValues("sectionNameTc"),
            newSectionNameEn: getValues("newSectionNameEn"),
            newSectionNameTc: getValues("newSectionNameTc"),
            newSectionNameSc: getValues("newSectionNameSc"),
            copyReo: getValues("copyReo"),
            status: getValues("status"),
            openDateTime: getValues("openDateTime"),
            closeDateTime: getValues("closeDateTime"),
            requiresSignature: getValues("requiresSignature"),
            collBoxGroupIdList:
                getValues("collBoxGroupList")?.map((group) => group.id) || [],
            telNo: getValues("telNo"),
            enRemark: getValues("enRemark"),
            scRemark: getValues("scRemark"),
            tcRemark: getValues("tcRemark"),
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/addCollBoxSection`,
            method: "POST",
            body: JSON.stringify(addFormNameItem),
        };
        dispatch(send("ADD_COLLBOX_FORM_NAME", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    reset(initialDefaultValues);
                    setValue("copyReo", "");
                    setValue("status", "");
                    setValue("requiresSignature", "");
                    setValue("collBoxGroupList", []);
                    setValue("openDateTime", null);
                    setValue("closeDateTime", null);

                    setAddFormNameMsg("");
                    initFormNameList();
                } else {
                    setAddFormNameMsg(result?.code);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function addNewReviewerItem() {
        const addReviewerItem = {
            collBoxGroupId: selectedGroup,
            post: addReviewer,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/addCollBoxGourpReviewer`,
            method: "POST",
            body: JSON.stringify(addReviewerItem),
        };
        dispatch(send("ADD_COLLBOX_FORM_NAME", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    initGroupList();
                    setAddReviewer("");
                    setAddReviewerMsg("");
                } else {
                    setAddReviewerMsg(result?.code);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function editGroupItem(group, index) {
        const editGroupItem = {
            id: group.id,
            groupNameEn: group.groupNameEn,
            groupNameSc: group.groupNameSc,
            groupNameTc: group.groupNameTc,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/updateCollBoxGroup`,
            method: "POST",
            body: JSON.stringify(editGroupItem),
        };
        dispatch(send("EDIT_COLLBOX_GROUP", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    const newGroupList = cloneDeep(groupList);
                    newGroupList[index].isEdit = false;
                    setGroupList(newGroupList);
                } else {
                    const newGroupList = cloneDeep(groupList);
                    newGroupList[index].errorMsg = result?.message;
                    setGroupList(newGroupList);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function editFormNameItem(sectionName, index) {
        const editFormNameItem = {
            id: sectionName.id,
            sectionNameEn: sectionName.sectionNameEn,
            sectionNameSc: sectionName.sectionNameSc,
            sectionNameTc: sectionName.sectionNameTc,
            newSectionNameEn: sectionName.newSectionNameEn,
            newSectionNameTc: sectionName.newSectionNameTc,
            newSectionNameSc: sectionName.newSectionNameSc,
            copyReo: sectionName.copyReo,
            status: sectionName.status,
            requiresSignature: sectionName.requiresSignature,
            openDateTime: sectionName.openDateTime,
            closeDateTime: sectionName.closeDateTime, // 添加结束时间
            collBoxGroupIdList:
                sectionName.collBoxGroupList?.map((group) => group.id) || [],
            telNo: sectionName.telNo,
            enRemark: sectionName.enRemark,
            scRemark: sectionName.scRemark,
            tcRemark: sectionName.tcRemark,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/updateCollBoxSection`,
            method: "POST",
            body: JSON.stringify(editFormNameItem),
        };
        dispatch(send("EDIT_COLLBOX_FORM_NAME", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    const newFormNameList = cloneDeep(sectionNameList);
                    newFormNameList[index].isEdit = false;
                    setFormNameList(newFormNameList);
                } else {
                    const newFormNameList = cloneDeep(sectionNameList);
                    newFormNameList[index].errorMsg = result?.message;
                    setFormNameList(newFormNameList);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function deleteReviewer(reviewer, index) {
        const oldReviewer = {
            id: reviewer.id,
            collBoxGroupId: reviewer.collBoxGroupId,
            post: reviewer.post,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/deleteCollBoxGourpReviewer`,
            method: "POST",
            body: JSON.stringify(oldReviewer),
        };
        dispatch(send("DELETE_COLLBOX_REVIEWER", option))
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    initGroupList();
                } else {
                    const reviewerList = cloneDeep(curReviewerList);
                    reviewerList[index].errorMsg = result?.message;
                    setCurReviewerList(reviewerList);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    const initGroupList = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/getAllCollBoxGroup`,
        };
        dispatch(send("GET_COLLBOX_GROUP", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    result?.data?.forEach((group) => {
                        group.title =
                            group?.[
                                `groupName${capitalizeFirstLetter(
                                    i18n.language
                                )}`
                            ];
                    });
                    setGroupList(result?.data);
                } else {
                    if (result?.code === "10") {
                        navigate("/forbidden");
                    }
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };

    const initFormNameList = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/collBox/getAllCollBoxSection`,
        };
        dispatch(send("GET_COLLBOX_FORM_NAME", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    result?.data?.forEach((formName) => {
                        formName.collBoxGroupList =
                            formName?.collBoxGroupList?.map((group) => {
                                return {
                                    title: group?.[
                                        `groupName${capitalizeFirstLetter(
                                            i18n.language
                                        )}`
                                    ],
                                    id: group?.id,
                                };
                            });
                    });
                    setFormNameList(result?.data);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };

    const capitalizeFirstLetter = (str) => {
        return str?.toLowerCase()?.replace(/\b\w+\b/g, function (word) {
            return word?.substring(0, 1)?.toUpperCase() + word?.substring(1);
        });
    };

    useEffect(() => {
        initGroupList();
        initFormNameList();
        if (isObjectNotEmpty(formState?.errors)) {
            const errorKey = Object.keys(formState?.errors);
            errorKey.map((key) => {
                trigger(key);
            });
        }
        if (isObjectNotEmpty(groupForm?.formState?.errors)) {
            const errorKey = Object.keys(groupForm?.formState?.errors);
            errorKey.map((key) => {
                groupForm?.trigger(key);
            });
        }
    }, [t]);

    useEffect(() => {
        if (isNotEmpty(selectedGroup)) {
            const reviewerList = groupList?.find(
                (group) => group.id === selectedGroup
            )?.collBoxReviewerList;
            setCurReviewerList(reviewerList);
        }
        const initOptionList = groupList?.map((group) => {
            return {
                id: group?.id,
                title: group.title,
            };
        });
        setGroupOptionList(initOptionList);
    }, [groupList]);

    return (
        <React.Fragment>
            <Container maxWidth="md">
                <Header
                    headerTitle={t("common.sideNavList.editPurpose")}
                    className="header"
                ></Header>
                <Box className="container">
                    <PortalNavbar aside className="drawer" />
                    <Box className="main" style={{ paddingLeft: "10px" }}>
                        {/* Part1:Groups */}
                        <Typography variant="h6" component="h1">
                            {t("common.portal.editCurrentGroup")}
                        </Typography>
                        <TableContainer
                            component={Paper}
                            style={{ maxHeight: 500 }}
                        >
                            <Table
                                stickyHeader
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.enName")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.tcName")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.scName")}
                                        </TableCell>

                                        <TableCell component="td"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isObjectNotEmpty(groupList) &&
                                    groupList != undefined
                                        ? groupList.map((item, index) => (
                                              <React.Fragment key={item.id}>
                                                  <TableRow
                                                      className={
                                                          classes.tableRow
                                                      }
                                                  >
                                                      <TableCell
                                                          align="center"
                                                          style={{
                                                              wordBreak:
                                                                  "break-word",
                                                              overflowWrap:
                                                                  "break-word",
                                                          }}
                                                      >
                                                          {item.isEdit ? (
                                                              <CustomTextField
                                                                  label={" "}
                                                                  required={
                                                                      false
                                                                  }
                                                                  displayColon={
                                                                      false
                                                                  }
                                                                  value={
                                                                      item.groupNameEn
                                                                  }
                                                                  onChange={(
                                                                      e
                                                                  ) => {
                                                                      const newGroupList =
                                                                          cloneDeep(
                                                                              groupList
                                                                          );
                                                                      newGroupList[
                                                                          index
                                                                      ].groupNameEn =
                                                                          e.target.value;
                                                                      setGroupList(
                                                                          newGroupList
                                                                      );
                                                                  }}
                                                                  error={(function (
                                                                      fieldValue
                                                                  ) {
                                                                      if (
                                                                          isEmpty(
                                                                              fieldValue
                                                                          )
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.required"
                                                                                  ),
                                                                          };
                                                                      } else if (
                                                                          fieldValue.length >
                                                                          200
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.maxTextLength",
                                                                                      {
                                                                                          max: 200,
                                                                                      }
                                                                                  ),
                                                                          };
                                                                      } else {
                                                                          return {};
                                                                      }
                                                                  })(
                                                                      item.groupNameEn
                                                                  )}
                                                              ></CustomTextField>
                                                          ) : (
                                                              item.groupNameEn
                                                          )}
                                                      </TableCell>
                                                      <TableCell
                                                          align="center"
                                                          style={{
                                                              wordBreak:
                                                                  "break-word",
                                                              overflowWrap:
                                                                  "break-word",
                                                          }}
                                                      >
                                                          {item.isEdit ? (
                                                              <CustomTextField
                                                                  label={" "}
                                                                  required={
                                                                      false
                                                                  }
                                                                  displayColon={
                                                                      false
                                                                  }
                                                                  value={
                                                                      item.groupNameTc
                                                                  }
                                                                  onChange={(
                                                                      e
                                                                  ) => {
                                                                      const newGroupList =
                                                                          cloneDeep(
                                                                              groupList
                                                                          );
                                                                      newGroupList[
                                                                          index
                                                                      ].groupNameTc =
                                                                          e.target.value;
                                                                      setGroupList(
                                                                          newGroupList
                                                                      );
                                                                  }}
                                                                  error={(function (
                                                                      fieldValue
                                                                  ) {
                                                                      if (
                                                                          isEmpty(
                                                                              fieldValue
                                                                          )
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.required"
                                                                                  ),
                                                                          };
                                                                      } else if (
                                                                          fieldValue.length >
                                                                          200
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.maxTextLength",
                                                                                      {
                                                                                          max: 200,
                                                                                      }
                                                                                  ),
                                                                          };
                                                                      } else {
                                                                          return {};
                                                                      }
                                                                  })(
                                                                      item.groupNameTc
                                                                  )}
                                                              ></CustomTextField>
                                                          ) : (
                                                              item.groupNameTc
                                                          )}
                                                      </TableCell>
                                                      <TableCell
                                                          align="center"
                                                          style={{
                                                              wordBreak:
                                                                  "break-word",
                                                              overflowWrap:
                                                                  "break-word",
                                                          }}
                                                      >
                                                          {item.isEdit ? (
                                                              <CustomTextField
                                                                  label={" "}
                                                                  required={
                                                                      false
                                                                  }
                                                                  displayColon={
                                                                      false
                                                                  }
                                                                  value={
                                                                      item.groupNameSc
                                                                  }
                                                                  onChange={(
                                                                      e
                                                                  ) => {
                                                                      const newGroupList =
                                                                          cloneDeep(
                                                                              groupList
                                                                          );
                                                                      newGroupList[
                                                                          index
                                                                      ].groupNameSc =
                                                                          e.target.value;
                                                                      setGroupList(
                                                                          newGroupList
                                                                      );
                                                                  }}
                                                                  error={(function (
                                                                      fieldValue
                                                                  ) {
                                                                      if (
                                                                          isEmpty(
                                                                              fieldValue
                                                                          )
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.required"
                                                                                  ),
                                                                          };
                                                                      } else if (
                                                                          fieldValue.length >
                                                                          200
                                                                      ) {
                                                                          return {
                                                                              message:
                                                                                  t(
                                                                                      "errorMsg.maxTextLength",
                                                                                      {
                                                                                          max: 200,
                                                                                      }
                                                                                  ),
                                                                          };
                                                                      } else {
                                                                          return {};
                                                                      }
                                                                  })(
                                                                      item.groupNameSc
                                                                  )}
                                                              ></CustomTextField>
                                                          ) : (
                                                              item.groupNameSc
                                                          )}
                                                      </TableCell>
                                                      <TableCell
                                                          style={{
                                                              width: "10px",
                                                          }}
                                                      >
                                                          {isAdmin ? (
                                                              item != null &&
                                                              item.isEdit ===
                                                                  true ? (
                                                                  <>
                                                                      <IconButton
                                                                          onClick={() => {
                                                                              const canEdit =
                                                                                  isNotEmpty(
                                                                                      item?.groupNameEn
                                                                                  ) &&
                                                                                  isNotEmpty(
                                                                                      item?.groupNameTc
                                                                                  ) &&
                                                                                  isNotEmpty(
                                                                                      item?.groupNameSc
                                                                                  ) &&
                                                                                  item
                                                                                      ?.groupNameEn
                                                                                      ?.length <=
                                                                                      200 &&
                                                                                  item
                                                                                      ?.groupNameTc
                                                                                      ?.length <=
                                                                                      200 &&
                                                                                  item
                                                                                      ?.groupNameSc
                                                                                      ?.length <=
                                                                                      200;

                                                                              if (
                                                                                  canEdit
                                                                              ) {
                                                                                  editGroupItem(
                                                                                      item,
                                                                                      index
                                                                                  );
                                                                              }
                                                                          }}
                                                                          color="primary"
                                                                          aria-label="edit"
                                                                      >
                                                                          <CheckCircleIcon />
                                                                      </IconButton>
                                                                      <IconButton
                                                                          onClick={() => {
                                                                              const newGroupList =
                                                                                  cloneDeep(
                                                                                      groupList
                                                                                  );
                                                                              const tempEditData =
                                                                                  newGroupList[
                                                                                      index
                                                                                  ]
                                                                                      ?.tempEditData;
                                                                              newGroupList[
                                                                                  index
                                                                              ] =
                                                                                  {
                                                                                      ...tempEditData,
                                                                                      ...{
                                                                                          isEdit: false,
                                                                                      },
                                                                                  };
                                                                              setGroupList(
                                                                                  newGroupList
                                                                              );
                                                                          }}
                                                                          color="primary"
                                                                          aria-label="cancel"
                                                                      >
                                                                          <CancelIcon />
                                                                      </IconButton>
                                                                  </>
                                                              ) : (
                                                                  <IconButton
                                                                      onClick={() => {
                                                                          const newGroupList =
                                                                              cloneDeep(
                                                                                  groupList
                                                                              );
                                                                          newGroupList[
                                                                              index
                                                                          ].isEdit = true;
                                                                          newGroupList[
                                                                              index
                                                                          ].tempEditData =
                                                                              item;
                                                                          setGroupList(
                                                                              newGroupList
                                                                          );
                                                                      }}
                                                                      color="primary"
                                                                      aria-label="editing"
                                                                  >
                                                                      <EditIcon />
                                                                  </IconButton>
                                                              )
                                                          ) : null}
                                                      </TableCell>
                                                  </TableRow>
                                                  {isNotEmpty(
                                                      item.errorMsg
                                                  ) && (
                                                      <TableRow
                                                          className={
                                                              classes.tableRow
                                                          }
                                                      >
                                                          <TableCell
                                                              align="center"
                                                              colSpan={5}
                                                          >
                                                              <Box
                                                                  name="errorMsg"
                                                                  display="flex"
                                                                  mt={2}
                                                              >
                                                                  <Box>
                                                                      <WarningRounded color="error" />
                                                                  </Box>
                                                                  <Box p={1}>
                                                                      <Typography
                                                                          component={
                                                                              "span"
                                                                          }
                                                                          color="error"
                                                                      >
                                                                          {
                                                                              item.errorMsg
                                                                          }
                                                                      </Typography>
                                                                  </Box>
                                                              </Box>
                                                          </TableCell>
                                                      </TableRow>
                                                  )}
                                              </React.Fragment>
                                          ))
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br />
                        {isAdmin ? (
                            <Paper style={{ padding: "5px" }}>
                                <form
                                    onSubmit={groupForm.handleSubmit(
                                        (data) => {
                                            addNewGroupItem();
                                            setAddGroupMsg("");
                                        },
                                        (error) => {
                                            console.log(error);
                                        }
                                    )}
                                >
                                    <Grid
                                        container
                                        style={{ marginBottom: "10px" }}
                                    >
                                        <Grid item xs={11}>
                                            <Box mb={4}>
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.enName"
                                                    )}
                                                    id="groupNameEn"
                                                    inputProps={{
                                                        ...groupForm.register(
                                                            "groupNameEn"
                                                        ),
                                                    }}
                                                    error={
                                                        groupForm?.formState
                                                            ?.errors
                                                            ?.groupNameEn
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Box>
                                            <Box mb={4}>
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.tcName"
                                                    )}
                                                    id="groupNameTc"
                                                    inputProps={{
                                                        ...groupForm.register(
                                                            "groupNameTc"
                                                        ),
                                                    }}
                                                    error={
                                                        groupForm?.formState
                                                            ?.errors
                                                            ?.groupNameTc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Box>
                                            <Box mb={4}>
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.scName"
                                                    )}
                                                    id="groupNameSc"
                                                    inputProps={{
                                                        ...groupForm.register(
                                                            "groupNameSc"
                                                        ),
                                                    }}
                                                    error={
                                                        groupForm?.formState
                                                            ?.errors
                                                            ?.groupNameSc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Box>
                                            <Box mb={4}>
                                                <CustomTextField
                                                    label={
                                                        <>
                                                            <Typography component="span">
                                                                {t(
                                                                    "common.portal.nameOfReviewerStart"
                                                                )}
                                                            </Typography>
                                                            <AddCircleIcon
                                                                style={{
                                                                    margin: "0 5px",
                                                                    color: "#A74128",
                                                                }}
                                                            />
                                                            <Typography component="span">
                                                                {t(
                                                                    "common.portal.nameOfReviewerEnd"
                                                                )}
                                                            </Typography>
                                                        </>
                                                    }
                                                    placeholder={t(
                                                        "common.portal.inputNameOfReviewer"
                                                    )}
                                                    id="reviewerEmail"
                                                    inputProps={{
                                                        ...groupForm.register(
                                                            "reviewerEmail"
                                                        ),
                                                    }}
                                                    error={
                                                        groupForm?.formState
                                                            ?.errors
                                                            ?.reviewerEmail
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column-reverse",
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => {}}
                                                color="primary"
                                                aria-label="nameOfReviewer"
                                                type="submit"
                                            >
                                                <AddCircleIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </form>
                                {isNotEmpty(addGroupMsg) ? (
                                    <Box name="errorMsg" display="flex" mt={3}>
                                        <Box>
                                            <WarningRounded color="error" />
                                        </Box>
                                        <Box p={1}>
                                            <Typography
                                                component={"span"}
                                                color="error"
                                            >
                                                {errorCodeList?.find(
                                                    (code) =>
                                                        code == addGroupMsg
                                                )
                                                    ? t(
                                                          `errorMsg.EditPurpose.${addGroupMsg}`
                                                      )
                                                    : t(
                                                          "errorMsg.unknownError"
                                                      )}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ) : null}
                            </Paper>
                        ) : null}
                        <br />
                        <Divider />
                        <br />
                        {/* Part2: Admin of each group */}
                        <Typography variant="h6" component="h1">
                            {t("common.portal.assignAdminForGroup")}
                        </Typography>
                        <Paper>
                            <FormControl id="admin">
                                <Select
                                    label="admin"
                                    inputProps={{
                                        "aria-labelledby": "admin",
                                    }}
                                    value={selectedGroup}
                                    style={{ textAlign: "end" }}
                                    onChange={(e) => {
                                        setSelectedGroup(e.target.value);
                                        const reviewerList = groupList?.find(
                                            (group) =>
                                                group.id === e.target.value
                                        )?.collBoxReviewerList;
                                        setCurReviewerList(reviewerList);
                                    }}
                                >
                                    {isObjectNotEmpty(groupList) &&
                                        groupList.map((element) => (
                                            <MenuItem
                                                value={element.id}
                                                key={element.id}
                                            >
                                                {element.title}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>

                            <br />
                            <TableContainer
                                component={Paper}
                                style={{ maxHeight: 500 }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {t("common.portal.post")}
                                            </TableCell>
                                            {/* <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t(
                                                "common.portal.interfaceUsername"
                                            )}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.email")}
                                        </TableCell> */}
                                            <TableCell component="td"></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {isObjectNotEmpty(curReviewerList) &&
                                            curReviewerList?.map(
                                                (item, index) => (
                                                    <React.Fragment
                                                        key={item.id}
                                                    >
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                {item.post}
                                                            </TableCell>
                                                            {/* <TableCell align="center">
                                                        {item.interfaceUsername}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <a
                                                            href={`mailto:${item.email}`}
                                                            style={{
                                                                color: "black",
                                                            }}
                                                        >
                                                            {item.email}
                                                        </a>
                                                    </TableCell> */}
                                                            <TableCell
                                                                style={{
                                                                    width: "10px",
                                                                }}
                                                            >
                                                                <IconButton
                                                                    onClick={() =>
                                                                        deleteReviewer(
                                                                            item,
                                                                            index
                                                                        )
                                                                    }
                                                                    color="primary"
                                                                    aria-label="delete"
                                                                    disabled={
                                                                        curReviewerList?.length <=
                                                                        1
                                                                    }
                                                                >
                                                                    <RemoveCircleIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                        {isNotEmpty(
                                                            item.errorMsg
                                                        ) && (
                                                            <TableRow
                                                                className={
                                                                    classes.tableRow
                                                                }
                                                            >
                                                                <TableCell
                                                                    align="center"
                                                                    colSpan={5}
                                                                >
                                                                    <Box
                                                                        name="errorMsg"
                                                                        display="flex"
                                                                        mt={2}
                                                                    >
                                                                        <Box>
                                                                            <WarningRounded color="error" />
                                                                        </Box>
                                                                        <Box
                                                                            p={
                                                                                1
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                component={
                                                                                    "span"
                                                                                }
                                                                                color="error"
                                                                            >
                                                                                {
                                                                                    item.errorMsg
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </React.Fragment>
                                                )
                                            )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <br />

                        <Paper>
                            <Box p={2}>
                                <CustomTextField
                                    label={
                                        <>
                                            <Typography component="span">
                                                {t(
                                                    "common.portal.nameOfReviewerStart"
                                                )}
                                            </Typography>
                                            <AddCircleIcon
                                                style={{
                                                    margin: "0 5px",
                                                    color: "#A74128",
                                                }}
                                            />
                                            <Typography component="span">
                                                {t(
                                                    "common.portal.nameOfReviewerEnd"
                                                )}
                                            </Typography>
                                        </>
                                    }
                                    id="nameOfAddReviewer"
                                    placeholder={t(
                                        "common.portal.inputNameOfReviewer"
                                    )}
                                    value={addReviewer}
                                    onChange={(e) =>
                                        setAddReviewer(e.target.value)
                                    }
                                    style={{ width: "90%" }}
                                ></CustomTextField>
                                <IconButton
                                    onClick={() => {
                                        if (isEmpty(addReviewer)) {
                                            setAddReviewerMsg("9999");
                                        } else {
                                            addNewReviewerItem();
                                        }
                                    }}
                                    style={{ marginTop: "0.8rem" }}
                                    color="primary"
                                    aria-label="adminEmail"
                                >
                                    <AddCircleIcon />
                                </IconButton>
                                {isNotEmpty(addReviewerMsg) ? (
                                    <Box name="errorMsg" display="flex" mt={3}>
                                        <Box>
                                            <WarningRounded color="error" />
                                        </Box>
                                        <Box p={1}>
                                            <Typography
                                                component={"span"}
                                                color="error"
                                            >
                                                {errorCodeList?.find(
                                                    (code) =>
                                                        code == addReviewerMsg
                                                )
                                                    ? t(
                                                          `errorMsg.EditPurpose.${addReviewerMsg}`
                                                      )
                                                    : t(
                                                          "errorMsg.unknownError"
                                                      )}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ) : null}
                            </Box>
                        </Paper>
                        <br />
                        <Divider />
                        <br />
                        {/* Part3:Forms of each group*/}
                        <Typography variant="h6" component="h1">
                            {t("common.portal.assignFormForGroup")}
                        </Typography>
                        <Paper style={{ overflowX: "auto" }}>
                            <TableContainer
                                ref={tableContainerRef}
                                component={Paper}
                                style={{ maxHeight: 750 }}
                            >
                                <Table
                                    size="small"
                                    aria-label="a dense table"
                                    style={{
                                        tableLayout: "fixed",
                                        width: "439%",
                                    }}
                                    stickyHeader
                                    className={classes.denseTable}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t("common.portal.enFormName")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t("common.portal.tcFormName")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t("common.portal.scFormName")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.formLinkENWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.formLinkTCWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.formLinkSCWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t("common.portal.status")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t(
                                                    "common.portal.openDateTime"
                                                )}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "18.84%",
                                                }}
                                            >
                                                {t(
                                                    "common.portal.closeDateTime"
                                                )}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "13.56%",
                                                }}
                                            >
                                                {t(
                                                    "common.portal.requiresSignature"
                                                )}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.enSectionNameWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.tcSectionNameWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: t(
                                                            "common.portal.scSectionNameWithBreak"
                                                        ),
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "12.56%",
                                                }}
                                            >
                                                {t(
                                                    "common.portal.copyClericalStaff"
                                                )}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "25.11%",
                                                }}
                                            >
                                                {t(
                                                    "common.portal.responsibleGroup"
                                                )}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "13.56%",
                                                }}
                                            >
                                                {t("common.portal.sectionTel")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "62.79%",
                                                }}
                                            >
                                                {t("common.portal.enRemark")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "62.79%",
                                                }}
                                            >
                                                {t("common.portal.tcRemark")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "62.79%",
                                                }}
                                            >
                                                {t("common.portal.scRemark")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                    width: "10.05%",
                                                }}
                                            ></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {isObjectNotEmpty(sectionNameList) &&
                                        sectionNameList != undefined
                                            ? sectionNameList?.map(
                                                  (item, index) => (
                                                      <React.Fragment
                                                          key={item.id}
                                                      >
                                                          <TableRow
                                                              ref={(el) =>
                                                                  (rowRefs.current[
                                                                      index
                                                                  ] = el)
                                                              }
                                                              className={
                                                                  classes.tableRow
                                                              }
                                                          >
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "18.84%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.sectionNameEn
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].sectionNameEn =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.sectionNameEn
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <span>
                                                                          {
                                                                              item.sectionNameEn
                                                                          }
                                                                      </span>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "18.84%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.sectionNameTc
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].sectionNameTc =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.sectionNameTc
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <span>
                                                                          {
                                                                              item.sectionNameTc
                                                                          }
                                                                      </span>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "18.84%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.sectionNameSc
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].sectionNameSc =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.sectionNameSc
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <span>
                                                                          {
                                                                              item.sectionNameSc
                                                                          }
                                                                      </span>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "12.56%",
                                                                  }}
                                                              >
                                                                  <div
                                                                      onClick={() =>
                                                                          !item.isEdit &&
                                                                          copyUrl(
                                                                              item.id,
                                                                              "en"
                                                                          )
                                                                      }
                                                                      title="Copy URL for English"
                                                                      style={{
                                                                          cursor: item.isEdit
                                                                              ? "not-allowed"
                                                                              : "pointer",
                                                                          opacity:
                                                                              item.isEdit
                                                                                  ? 0.4
                                                                                  : 1,
                                                                      }}
                                                                  >
                                                                      <IconButton
                                                                          size="small"
                                                                          disabled={
                                                                              item.isEdit
                                                                          }
                                                                          style={{
                                                                              color: item.isEdit
                                                                                  ? "gray"
                                                                                  : "green",
                                                                              pointerEvents:
                                                                                  "none",
                                                                          }}
                                                                      >
                                                                          <img
                                                                              src={
                                                                                  copyLinkIcon
                                                                              }
                                                                              alt="Copy Link"
                                                                              style={{
                                                                                  width: 30,
                                                                                  height: 30,
                                                                              }}
                                                                          />
                                                                      </IconButton>
                                                                      <div
                                                                          style={{
                                                                              fontSize: 10,
                                                                              textAlign:
                                                                                  "center",
                                                                          }}
                                                                      >
                                                                          Copy
                                                                          Link
                                                                      </div>
                                                                  </div>
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "12.56%",
                                                                  }}
                                                              >
                                                                  <div
                                                                      onClick={() =>
                                                                          !item.isEdit &&
                                                                          copyUrl(
                                                                              item.id,
                                                                              "tc"
                                                                          )
                                                                      }
                                                                      title="Copy URL for Traditional Chinese"
                                                                      style={{
                                                                          cursor: item.isEdit
                                                                              ? "not-allowed"
                                                                              : "pointer",
                                                                          opacity:
                                                                              item.isEdit
                                                                                  ? 0.4
                                                                                  : 1,
                                                                      }}
                                                                  >
                                                                      <IconButton
                                                                          size="small"
                                                                          disabled={
                                                                              item.isEdit
                                                                          }
                                                                          style={{
                                                                              color: item.isEdit
                                                                                  ? "gray"
                                                                                  : "green",
                                                                              pointerEvents:
                                                                                  "none",
                                                                          }}
                                                                      >
                                                                          <img
                                                                              src={
                                                                                  copyLinkIcon
                                                                              }
                                                                              alt="Copy Link"
                                                                              style={{
                                                                                  width: 30,
                                                                                  height: 30,
                                                                              }}
                                                                          />
                                                                      </IconButton>
                                                                      <div
                                                                          style={{
                                                                              fontSize: 10,
                                                                              textAlign:
                                                                                  "center",
                                                                          }}
                                                                      >
                                                                          複製連結
                                                                      </div>
                                                                  </div>
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "12.56%",
                                                                  }}
                                                              >
                                                                  <div
                                                                      onClick={() =>
                                                                          !item.isEdit &&
                                                                          copyUrl(
                                                                              item.id,
                                                                              "sc"
                                                                          )
                                                                      }
                                                                      title="Copy URL for Simplified Chinese"
                                                                      style={{
                                                                          cursor: item.isEdit
                                                                              ? "not-allowed"
                                                                              : "pointer",
                                                                          opacity:
                                                                              item.isEdit
                                                                                  ? 0.4
                                                                                  : 1,
                                                                      }}
                                                                  >
                                                                      <IconButton
                                                                          size="small"
                                                                          disabled={
                                                                              item.isEdit
                                                                          }
                                                                          style={{
                                                                              color: item.isEdit
                                                                                  ? "gray"
                                                                                  : "green",
                                                                              pointerEvents:
                                                                                  "none",
                                                                          }}
                                                                      >
                                                                          <img
                                                                              src={
                                                                                  copyLinkIcon
                                                                              }
                                                                              alt="Copy Link"
                                                                              style={{
                                                                                  width: 30,
                                                                                  height: 30,
                                                                              }}
                                                                          />
                                                                      </IconButton>
                                                                      <div
                                                                          style={{
                                                                              fontSize: 10,
                                                                              textAlign:
                                                                                  "center",
                                                                          }}
                                                                      >
                                                                          复制连结
                                                                      </div>
                                                                  </div>
                                                              </TableCell>

                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "18.84%",
                                                                  }}
                                                              >
                                                                  <RadioGroup
                                                                      name="item.status"
                                                                      value={
                                                                          item.status
                                                                      }
                                                                      onChange={(
                                                                          e
                                                                      ) => {
                                                                          if (
                                                                              item.isEdit
                                                                          ) {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].status =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }
                                                                      }}
                                                                      style={{
                                                                          alignItems:
                                                                              "center",
                                                                      }}
                                                                  >
                                                                      <FormControlLabel
                                                                          value="active"
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.portal.active"
                                                                          )}
                                                                      />
                                                                      <FormControlLabel
                                                                          value="inactive"
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.portal.inactive"
                                                                          )}
                                                                      />
                                                                  </RadioGroup>
                                                              </TableCell>
                                                              <TableCell
                                                                  className={
                                                                      classes.shortGrid
                                                                  }
                                                                  align="center"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "18.84%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <DatePicker
                                                                          selected={
                                                                              typeof item.openDateTime ===
                                                                              "string"
                                                                                  ? moment
                                                                                        .tz(
                                                                                            item.openDateTime,
                                                                                            "Asia/Hong_Kong"
                                                                                        )
                                                                                        .toDate()
                                                                                  : item.openDateTime
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].openDateTime =
                                                                                  e;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          showTimeInput
                                                                          dateFormat="dd/MM/yyyy h:mm aa"
                                                                          timeFormat="h:mm aa"
                                                                          timeIntervals={
                                                                              1
                                                                          }
                                                                          placeholderText={
                                                                              i18n.language ===
                                                                              "en"
                                                                                  ? "DD/MM/YYYY HH:mm"
                                                                                  : "日/月/年 时:分"
                                                                          }
                                                                          showMonthDropdown
                                                                          showYearDropdown
                                                                          useWeekdaysShort={
                                                                              i18n.language ===
                                                                              "en"
                                                                          }
                                                                          dropdownMode="select"
                                                                          locale={
                                                                              lang
                                                                          }
                                                                          className="form-control"
                                                                          showPopperArrow={
                                                                              false
                                                                          }
                                                                      />
                                                                  ) : item.openDateTime ? (
                                                                      moment
                                                                          .tz(
                                                                              item.openDateTime,
                                                                              "Asia/Hong_Kong"
                                                                          )
                                                                          .format(
                                                                              "DD/MM/YYYY h:mm A"
                                                                          )
                                                                  ) : (
                                                                      item.openDateTime
                                                                  )}
                                                                  {item.isEdit && (
                                                                      <ErrorMsg
                                                                          message={(function (
                                                                              openDateTimeValue,
                                                                              closeDateTimeValue
                                                                          ) {
                                                                              if (
                                                                                  openDateTimeValue &&
                                                                                  closeDateTimeValue
                                                                              ) {
                                                                                  if (
                                                                                      new Date(
                                                                                          openDateTimeValue
                                                                                      ) >
                                                                                      new Date(
                                                                                          closeDateTimeValue
                                                                                      )
                                                                                  ) {
                                                                                      return t(
                                                                                          "errorMsg.openTimeBeforeCloseTime"
                                                                                      );
                                                                                  }
                                                                              }
                                                                              return null;
                                                                          })(
                                                                              item.openDateTime,
                                                                              item.closeDateTime
                                                                          )}
                                                                      />
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  className={
                                                                      classes.shortGrid
                                                                  }
                                                                  align="center"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "18.84%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <DatePicker
                                                                          selected={
                                                                              typeof item.closeDateTime ===
                                                                              "string"
                                                                                  ? moment
                                                                                        .tz(
                                                                                            item.closeDateTime,
                                                                                            "Asia/Hong_Kong"
                                                                                        )
                                                                                        .toDate()
                                                                                  : item.closeDateTime
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].closeDateTime =
                                                                                  e;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          showTimeInput
                                                                          dateFormat="dd/MM/yyyy h:mm aa"
                                                                          timeFormat="h:mm aa"
                                                                          timeIntervals={
                                                                              1
                                                                          }
                                                                          placeholderText={
                                                                              i18n.language ===
                                                                              "en"
                                                                                  ? "DD/MM/YYYY HH:mm"
                                                                                  : "日/月/年 时:分"
                                                                          }
                                                                          useWeekdaysShort={
                                                                              i18n.language ===
                                                                              "en"
                                                                          }
                                                                          showMonthDropdown
                                                                          showYearDropdown
                                                                          dropdownMode="select"
                                                                          locale={
                                                                              lang
                                                                          }
                                                                          className="form-control"
                                                                          showPopperArrow={
                                                                              false
                                                                          }
                                                                      />
                                                                  ) : item.closeDateTime ? (
                                                                      moment
                                                                          .tz(
                                                                              item.closeDateTime,
                                                                              "Asia/Hong_Kong"
                                                                          )
                                                                          .format(
                                                                              "DD/MM/YYYY h:mm A"
                                                                          )
                                                                  ) : (
                                                                      item.closeDateTime
                                                                  )}
                                                                  {item.isEdit && (
                                                                      <ErrorMsg
                                                                          message={(function (
                                                                              openDateTimeValue,
                                                                              closeDateTimeValue
                                                                          ) {
                                                                              if (
                                                                                  openDateTimeValue &&
                                                                                  closeDateTimeValue
                                                                              ) {
                                                                                  if (
                                                                                      new Date(
                                                                                          closeDateTimeValue
                                                                                      ) <
                                                                                      new Date(
                                                                                          openDateTimeValue
                                                                                      )
                                                                                  ) {
                                                                                      return t(
                                                                                          "errorMsg.closeTimeAfterOpenTime"
                                                                                      );
                                                                                  }
                                                                              }
                                                                              return null;
                                                                          })(
                                                                              item.openDateTime,
                                                                              item.closeDateTime
                                                                          )}
                                                                      />
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "13.56%",
                                                                  }}
                                                              >
                                                                  <RadioGroup
                                                                      name="item.requiresSignature"
                                                                      style={{
                                                                          alignItems:
                                                                              "center",
                                                                      }}
                                                                      value={
                                                                          item.requiresSignature
                                                                      }
                                                                      onChange={(
                                                                          e
                                                                      ) => {
                                                                          if (
                                                                              item.isEdit
                                                                          ) {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].requiresSignature =
                                                                                  e
                                                                                      .target
                                                                                      .value ===
                                                                                  "false"
                                                                                      ? false
                                                                                      : true;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }
                                                                      }}
                                                                  >
                                                                      <FormControlLabel
                                                                          value={
                                                                              true
                                                                          }
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.yes"
                                                                          )}
                                                                      />
                                                                      <FormControlLabel
                                                                          value={
                                                                              false
                                                                          }
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.no"
                                                                          )}
                                                                      />
                                                                  </RadioGroup>
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "12.56%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.newSectionNameEn
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].newSectionNameEn =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.newSectionNameEn
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      item.newSectionNameEn
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "12.56%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.newSectionNameTc
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].newSectionNameTc =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.newSectionNameTc
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      item.newSectionNameTc
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "12.56%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.newSectionNameSc
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].newSectionNameSc =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              fieldValue
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      fieldValue
                                                                                  )
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.required"
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  fieldValue.length >
                                                                                  300
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 300,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.newSectionNameSc
                                                                          )}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      item.newSectionNameSc
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "12.56%",
                                                                  }}
                                                              >
                                                                  <RadioGroup
                                                                      name="item.copyReo"
                                                                      value={
                                                                          item.copyReo
                                                                      }
                                                                      onChange={(
                                                                          e
                                                                      ) => {
                                                                          if (
                                                                              item.isEdit
                                                                          ) {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].copyReo =
                                                                                  e
                                                                                      .target
                                                                                      .value ===
                                                                                  "false"
                                                                                      ? false
                                                                                      : true;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }
                                                                      }}
                                                                      style={{
                                                                          alignItems:
                                                                              "center",
                                                                      }}
                                                                  >
                                                                      <FormControlLabel
                                                                          value={
                                                                              true
                                                                          }
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.yes"
                                                                          )}
                                                                      />
                                                                      <FormControlLabel
                                                                          value={
                                                                              false
                                                                          }
                                                                          control={
                                                                              <Radio
                                                                                  disabled={
                                                                                      !item.isEdit
                                                                                  }
                                                                              />
                                                                          }
                                                                          label={t(
                                                                              "common.no"
                                                                          )}
                                                                      />
                                                                  </RadioGroup>
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      width: "25.11%",
                                                                      overflowWrap:
                                                                          "break-word",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <>
                                                                          <Autocomplete
                                                                              options={
                                                                                  groupOptionList
                                                                              }
                                                                              getOptionLabel={(
                                                                                  option
                                                                              ) =>
                                                                                  option.title
                                                                              }
                                                                              value={
                                                                                  item.collBoxGroupList
                                                                              }
                                                                              multiple
                                                                              renderInput={(
                                                                                  params
                                                                              ) => (
                                                                                  <TextField
                                                                                      {...params}
                                                                                      variant="standard"
                                                                                  />
                                                                              )}
                                                                              renderOption={(
                                                                                  props,
                                                                                  option,
                                                                                  {
                                                                                      selected,
                                                                                  }
                                                                              ) => {
                                                                                  return (
                                                                                      <li
                                                                                          {...props}
                                                                                      >
                                                                                          <Checkbox
                                                                                              icon={
                                                                                                  icon
                                                                                              }
                                                                                              checkedIcon={
                                                                                                  checkedIcon
                                                                                              }
                                                                                              style={{
                                                                                                  marginRight: 8,
                                                                                              }}
                                                                                              checked={Boolean(
                                                                                                  item.collBoxGroupList?.find(
                                                                                                      (
                                                                                                          group
                                                                                                      ) =>
                                                                                                          group.id ===
                                                                                                          option.id
                                                                                                  )
                                                                                              )}
                                                                                          />
                                                                                          {
                                                                                              option.title
                                                                                          }
                                                                                      </li>
                                                                                  );
                                                                              }}
                                                                              disableCloseOnSelect
                                                                              isOptionEqualToValue={(
                                                                                  option,
                                                                                  value
                                                                              ) =>
                                                                                  option.id ===
                                                                                  value.id
                                                                              }
                                                                              onChange={(
                                                                                  e,
                                                                                  newValue
                                                                              ) => {
                                                                                  const newFormNameList =
                                                                                      cloneDeep(
                                                                                          sectionNameList
                                                                                      );
                                                                                  newFormNameList[
                                                                                      index
                                                                                  ].collBoxGroupList =
                                                                                      newValue;
                                                                                  setFormNameList(
                                                                                      newFormNameList
                                                                                  );
                                                                              }}
                                                                              style={{
                                                                                  width: "100%",
                                                                              }}
                                                                          />
                                                                          {isEmpty(
                                                                              item?.collBoxGroupList
                                                                          ) &&
                                                                              item?.status ===
                                                                                  "active" && (
                                                                                  <Box
                                                                                      name="errorMsg"
                                                                                      display="flex"
                                                                                      mt={
                                                                                          2
                                                                                      }
                                                                                  >
                                                                                      <Box>
                                                                                          <WarningRounded color="error" />
                                                                                      </Box>
                                                                                      <Box
                                                                                          p={
                                                                                              1
                                                                                          }
                                                                                      >
                                                                                          <Typography
                                                                                              component={
                                                                                                  "span"
                                                                                              }
                                                                                              color="error"
                                                                                          >
                                                                                              {t(
                                                                                                  "errorMsg.required"
                                                                                              )}
                                                                                          </Typography>
                                                                                      </Box>
                                                                                  </Box>
                                                                              )}
                                                                      </>
                                                                  ) : item
                                                                        ?.collBoxGroupList
                                                                        ?.length ? (
                                                                      item?.collBoxGroupList
                                                                          ?.map?.(
                                                                              (
                                                                                  group
                                                                              ) =>
                                                                                  group?.title
                                                                          )
                                                                          ?.join(
                                                                              ","
                                                                          )
                                                                  ) : (
                                                                      ""
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "13.56%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.telNo
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].telNo =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          error={(function (
                                                                              telNo
                                                                          ) {
                                                                              if (
                                                                                  isEmpty(
                                                                                      telNo
                                                                                  )
                                                                              ) {
                                                                                  return {};
                                                                              } else if (
                                                                                  telNo?.length <
                                                                                  8
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.minTextLength",
                                                                                              {
                                                                                                  min: 8,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else if (
                                                                                  telNo?.length >
                                                                                  50
                                                                              ) {
                                                                                  return {
                                                                                      message:
                                                                                          t(
                                                                                              "errorMsg.maxTextLength",
                                                                                              {
                                                                                                  max: 50,
                                                                                              }
                                                                                          ),
                                                                                  };
                                                                              } else {
                                                                                  return {};
                                                                              }
                                                                          })(
                                                                              item.telNo
                                                                          )}
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      item.telNo
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "62.79%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.enRemark
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].enRemark =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                          error={
                                                                              item
                                                                                  ?.enRemark
                                                                                  ?.length >
                                                                              5000
                                                                                  ? {
                                                                                        message:
                                                                                            t(
                                                                                                "errorMsg.maxTextLength",
                                                                                                {
                                                                                                    max: 5000,
                                                                                                }
                                                                                            ),
                                                                                    }
                                                                                  : {}
                                                                          }
                                                                          fullWidth={
                                                                              true
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <div
                                                                          style={{
                                                                              whiteSpace:
                                                                                  "pre-wrap",
                                                                          }}
                                                                      >
                                                                          {
                                                                              item.enRemark
                                                                          }
                                                                      </div>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "62.79%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.tcRemark
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].tcRemark =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                          error={
                                                                              item
                                                                                  ?.tcRemark
                                                                                  ?.length >
                                                                              5000
                                                                                  ? {
                                                                                        message:
                                                                                            t(
                                                                                                "errorMsg.maxTextLength",
                                                                                                {
                                                                                                    max: 5000,
                                                                                                }
                                                                                            ),
                                                                                    }
                                                                                  : {}
                                                                          }
                                                                          fullWidth={
                                                                              true
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <div
                                                                          style={{
                                                                              whiteSpace:
                                                                                  "pre-wrap",
                                                                          }}
                                                                      >
                                                                          {
                                                                              item.tcRemark
                                                                          }
                                                                      </div>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell
                                                                  align="left"
                                                                  style={{
                                                                      overflowWrap:
                                                                          "break-word",
                                                                      width: "62.79%",
                                                                  }}
                                                              >
                                                                  {item.isEdit ? (
                                                                      <CustomTextField
                                                                          label={
                                                                              " "
                                                                          }
                                                                          required={
                                                                              false
                                                                          }
                                                                          displayColon={
                                                                              false
                                                                          }
                                                                          value={
                                                                              item.scRemark
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) => {
                                                                              const newFormNameList =
                                                                                  cloneDeep(
                                                                                      sectionNameList
                                                                                  );
                                                                              newFormNameList[
                                                                                  index
                                                                              ].scRemark =
                                                                                  e.target.value;
                                                                              setFormNameList(
                                                                                  newFormNameList
                                                                              );
                                                                          }}
                                                                          multiline
                                                                          maxRows={
                                                                              5
                                                                          }
                                                                          error={
                                                                              item
                                                                                  ?.scRemark
                                                                                  ?.length >
                                                                              5000
                                                                                  ? {
                                                                                        message:
                                                                                            t(
                                                                                                "errorMsg.maxTextLength",
                                                                                                {
                                                                                                    max: 5000,
                                                                                                }
                                                                                            ),
                                                                                    }
                                                                                  : {}
                                                                          }
                                                                          fullWidth={
                                                                              true
                                                                          }
                                                                      ></CustomTextField>
                                                                  ) : (
                                                                      <div
                                                                          style={{
                                                                              whiteSpace:
                                                                                  "pre-wrap",
                                                                          }}
                                                                      >
                                                                          {
                                                                              item.scRemark
                                                                          }
                                                                      </div>
                                                                  )}
                                                              </TableCell>

                                                              <TableCell
                                                                  align="center"
                                                                  style={{
                                                                      width: "10.05%",
                                                                  }}
                                                              >
                                                                  {isAdmin ? (
                                                                      item !=
                                                                          null &&
                                                                      item.isEdit ===
                                                                          true ? (
                                                                          <>
                                                                              <IconButton
                                                                                  onClick={() => {
                                                                                      const canEdit =
                                                                                          isNotEmpty(
                                                                                              item.sectionNameEn
                                                                                          ) &&
                                                                                          isNotEmpty(
                                                                                              item.sectionNameTc
                                                                                          ) &&
                                                                                          isNotEmpty(
                                                                                              item.sectionNameSc
                                                                                          ) &&
                                                                                          item
                                                                                              ?.sectionNameEn
                                                                                              ?.length <=
                                                                                              300 &&
                                                                                          item
                                                                                              ?.sectionNameTc
                                                                                              ?.length <=
                                                                                              300 &&
                                                                                          item
                                                                                              ?.sectionNameSc
                                                                                              ?.length <=
                                                                                              300 &&
                                                                                          (item
                                                                                              ?.enRemark
                                                                                              ?.length <=
                                                                                              5000 ||
                                                                                              isEmpty(
                                                                                                  item?.enRemark
                                                                                              )) &&
                                                                                          (item
                                                                                              ?.tcRemark
                                                                                              ?.length <=
                                                                                              5000 ||
                                                                                              isEmpty(
                                                                                                  item?.tcRemark
                                                                                              )) &&
                                                                                          (item
                                                                                              ?.scRemark
                                                                                              ?.length <=
                                                                                              5000 ||
                                                                                              isEmpty(
                                                                                                  item?.scRemark
                                                                                              )) &&
                                                                                          (item
                                                                                              ?.collBoxGroupList
                                                                                              ?.length >
                                                                                              0 ||
                                                                                              item?.status ===
                                                                                                  "inactive") &&
                                                                                          (isEmpty(
                                                                                              item.telNo
                                                                                          ) ||
                                                                                              (isNotEmpty(
                                                                                                  item.telNo
                                                                                              ) &&
                                                                                                  item
                                                                                                      ?.telNo
                                                                                                      ?.length >=
                                                                                                      8 &&
                                                                                                  item
                                                                                                      ?.telNo
                                                                                                      ?.length <=
                                                                                                      50)) &&
                                                                                          (!item.openDateTime ||
                                                                                              !item.closeDateTime ||
                                                                                              new Date(
                                                                                                  item.openDateTime
                                                                                              ) <=
                                                                                                  new Date(
                                                                                                      item.closeDateTime
                                                                                                  ));
                                                                                      if (
                                                                                          canEdit
                                                                                      ) {
                                                                                          editFormNameItem(
                                                                                              item,
                                                                                              index
                                                                                          );
                                                                                      }
                                                                                  }}
                                                                                  color="primary"
                                                                                  aria-label="edit"
                                                                              >
                                                                                  <CheckCircleIcon />
                                                                              </IconButton>

                                                                              <IconButton
                                                                                  onClick={() => {
                                                                                      const newFormNameList =
                                                                                          cloneDeep(
                                                                                              sectionNameList
                                                                                          );
                                                                                      const tempEditData =
                                                                                          newFormNameList[
                                                                                              index
                                                                                          ]
                                                                                              ?.tempEditData;
                                                                                      newFormNameList[
                                                                                          index
                                                                                      ] =
                                                                                          {
                                                                                              ...tempEditData,
                                                                                              ...{
                                                                                                  isEdit: false,
                                                                                              },
                                                                                          };
                                                                                      setFormNameList(
                                                                                          newFormNameList
                                                                                      );
                                                                                  }}
                                                                                  color="primary"
                                                                                  aria-label="cancel"
                                                                              >
                                                                                  <CancelIcon />
                                                                              </IconButton>
                                                                          </>
                                                                      ) : (
                                                                          <IconButton
                                                                              onClick={() => {
                                                                                  const newFormNameList =
                                                                                      cloneDeep(
                                                                                          sectionNameList
                                                                                      );
                                                                                  newFormNameList[
                                                                                      index
                                                                                  ].isEdit = true;
                                                                                  newFormNameList[
                                                                                      index
                                                                                  ].tempEditData =
                                                                                      item;
                                                                                  setFormNameList(
                                                                                      newFormNameList
                                                                                  );
                                                                                  scrollToRow(
                                                                                      index
                                                                                  );
                                                                              }}
                                                                              color="primary"
                                                                              aria-label="editing"
                                                                          >
                                                                              <EditIcon />
                                                                          </IconButton>
                                                                      )
                                                                  ) : null}
                                                              </TableCell>
                                                          </TableRow>
                                                          {isNotEmpty(
                                                              item.errorMsg
                                                          ) && (
                                                              <TableRow
                                                                  className={
                                                                      classes.tableRow
                                                                  }
                                                              >
                                                                  <TableCell
                                                                      align="center"
                                                                      colSpan={
                                                                          5
                                                                      }
                                                                  >
                                                                      <Box
                                                                          name="errorMsg"
                                                                          display="flex"
                                                                          mt={2}
                                                                      >
                                                                          <Box>
                                                                              <WarningRounded color="error" />
                                                                          </Box>
                                                                          <Box
                                                                              p={
                                                                                  1
                                                                              }
                                                                          >
                                                                              <Typography
                                                                                  component={
                                                                                      "span"
                                                                                  }
                                                                                  color="error"
                                                                              >
                                                                                  {
                                                                                      item.errorMsg
                                                                                  }
                                                                              </Typography>
                                                                          </Box>
                                                                      </Box>
                                                                  </TableCell>
                                                              </TableRow>
                                                          )}
                                                      </React.Fragment>
                                                  )
                                              )
                                            : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <br />
                        {isAdmin ? (
                            <Paper style={{ padding: "5px" }}>
                                <form
                                    onSubmit={handleSubmit(
                                        (data) => {
                                            addNewFormNameItem();
                                            setAddFormNameMsg("");
                                        },
                                        (error) => {
                                            console.log(error);
                                        }
                                    )}
                                >
                                    <Grid container>
                                        <Grid container item xs={11}>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.enFormName"
                                                    )}
                                                    id="sectionNameEn"
                                                    inputProps={{
                                                        ...register(
                                                            "sectionNameEn"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.sectionNameEn
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.tcFormName"
                                                    )}
                                                    id="sectionNameTc"
                                                    inputProps={{
                                                        ...register(
                                                            "sectionNameTc"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.sectionNameTc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.scFormName"
                                                    )}
                                                    id="sectionNameSc"
                                                    inputProps={{
                                                        ...register(
                                                            "sectionNameSc"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.sectionNameSc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomRadioGroup
                                                    control={control}
                                                    id="addFormName.status"
                                                    label={t(
                                                        "common.portal.status"
                                                    )}
                                                    name="status"
                                                    row
                                                    options={{
                                                        active: t(
                                                            "common.portal.active"
                                                        ),
                                                        inactive: t(
                                                            "common.portal.inactive"
                                                        ),
                                                    }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomDatePicker
                                                    label={t(
                                                        "common.portal.openDateTime"
                                                    )}
                                                    name="openDateTime"
                                                    control={control}
                                                    type="dateTime"
                                                    required={false}
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomDatePicker
                                                    label={t(
                                                        "common.portal.closeDateTime"
                                                    )}
                                                    name="closeDateTime"
                                                    control={control}
                                                    type="dateTime"
                                                    required={false}
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomRadioGroup
                                                    control={control}
                                                    id="addFormName.requiresSignature"
                                                    label={t(
                                                        "common.portal.requiresSignature"
                                                    )}
                                                    name="requiresSignature"
                                                    row
                                                    options={{
                                                        true: t("common.yes"),
                                                        false: t("common.no"),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.enSectionName"
                                                    )}
                                                    id="newSectionNameEn"
                                                    inputProps={{
                                                        ...register(
                                                            "newSectionNameEn"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.newSectionNameEn
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.tcSectionName"
                                                    )}
                                                    id="newSectionNameTc"
                                                    inputProps={{
                                                        ...register(
                                                            "newSectionNameTc"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.newSectionNameTc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.scSectionName"
                                                    )}
                                                    id="newSectionNameSc"
                                                    inputProps={{
                                                        ...register(
                                                            "newSectionNameSc"
                                                        ),
                                                    }}
                                                    error={
                                                        errors?.newSectionNameSc
                                                    }
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <CustomRadioGroup
                                                control={control}
                                                id="addFormName.copyReo"
                                                label={t(
                                                    "common.portal.copyClericalStaff"
                                                )}
                                                name="copyReo"
                                                row
                                                options={{
                                                    true: t("common.yes"),
                                                    false: t("common.no"),
                                                }}
                                            />
                                            <Grid
                                                item
                                                xs={12}
                                                className={classes.statusRadio}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <InputLabel shrink>
                                                    {t(
                                                        "common.portal.responsibleGroup"
                                                    )}
                                                    {t("common.colon")}
                                                    {watch("status") ===
                                                        "active" && (
                                                        <Box
                                                            component="span"
                                                            className="danger"
                                                        >
                                                            *
                                                        </Box>
                                                    )}
                                                </InputLabel>
                                                <CustomMultiSelect
                                                    id="collBoxGroupList"
                                                    control={control}
                                                    checkBoxIcon={true}
                                                    name="collBoxGroupList"
                                                    value={watch(
                                                        "collBoxGroupList"
                                                    )}
                                                    selectOptions={
                                                        groupOptionList
                                                    }
                                                    getOptionLabel={(option) =>
                                                        option.title
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.sectionTel"
                                                    )}
                                                    id="telNo"
                                                    inputProps={{
                                                        ...register("telNo"),
                                                    }}
                                                    error={errors?.telNo}
                                                    required={false}
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.enRemark"
                                                    )}
                                                    id="enRemark"
                                                    inputProps={{
                                                        ...register("enRemark"),
                                                    }}
                                                    error={errors?.enRemark}
                                                    required={false}
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.tcRemark"
                                                    )}
                                                    id="tcRemark"
                                                    inputProps={{
                                                        ...register("tcRemark"),
                                                    }}
                                                    error={errors?.tcRemark}
                                                    required={false}
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <CustomTextField
                                                    label={t(
                                                        "common.portal.scRemark"
                                                    )}
                                                    id="scRemark"
                                                    inputProps={{
                                                        ...register("scRemark"),
                                                    }}
                                                    error={errors?.scRemark}
                                                    required={false}
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                ></CustomTextField>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column-reverse",
                                            }}
                                        >
                                            <IconButton
                                                color="primary"
                                                aria-label="emailOfAdmin"
                                                type="submit"
                                            >
                                                <AddCircleIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                    {isNotEmpty(addFormNameMsg) ? (
                                        <Box
                                            name="errorMsg"
                                            display="flex"
                                            mt={3}
                                        >
                                            <Box>
                                                <WarningRounded color="error" />
                                            </Box>
                                            <Box p={1}>
                                                <Typography
                                                    component={"span"}
                                                    color="error"
                                                >
                                                    {errorCodeList?.find(
                                                        (code) =>
                                                            code ==
                                                            addFormNameMsg
                                                    )
                                                        ? t(
                                                              `errorMsg.EditPurpose.${addFormNameMsg}`
                                                          )
                                                        : t(
                                                              "errorMsg.unknownError"
                                                          )}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    ) : null}
                                </form>
                            </Paper>
                        ) : null}
                        <br />
                    </Box>
                </Box>
            </Container>

            <Dialog open={copySuccessOpen}>
                <DialogContent>
                    <Typography>{t("common.portal.copySuccess")}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setCopySuccessOpen(false)}
                        color="success"
                    >
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default EditPurpose;
